<template>
    <div v-if="model" class="ml-3 mr-3">
        <h5 class="text-center mb-4">EMPLOYEE'S ATTORNEY</h5>
        <div class="form-row mb-2">
            <label class="col-3">Name</label>
            <input type="text" class="form-control col" list="contact-options" placeholder="Name" :value="model.name" @input="onInput($event.target.value)" />
            <datalist id="contact-options">
                <option v-for="contact in contacts" :key="contact.id" :value="contact.full_name" v-text="contact.full_name"></option>
            </datalist>            
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Street or Box</label>
            <input type="text" class="form-control col" placeholder="Street or Box" v-model="model.address" />
        </div>
        <div class="form-row mb-2">        
            <label class="col-3">City</label>
            <input type="text" class="form-control col" placeholder="City" v-model="model.city" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">State</label>
            <select id="patient_state" class="custom-select col" v-model="model.state">
                <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
            </select>
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Zip</label>
            <input type="text" class="form-control col" placeholder="Postal Code" v-model="model.postalCode" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Phone</label>     
            <telephone-input class="form-control col" placeholder="Phone" v-model="model.telephone"></telephone-input>
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Fax</label>
            <telephone-input class="form-control col" placeholder="Fax" v-model="model.fax"></telephone-input>
        </div>      
    </div>
</template>

<script>
export default {
    props: {
        model: Object,
        states: Array,
        contacts: Array,
    },
    methods: {
        onInput: function (value) {
            let contact = this.contacts.find( (o) => { return o.full_name.toUpperCase() === value.toUpperCase(); });
            if (contact) {
                this.model.name = contact.full_name;
                this.model.address = contact.address;
                this.model.city = contact.city;
                this.model.state = contact.state;
                this.model.postalCode = contact.postal_code;
                this.model.telephone = contact.telephone;
                this.model.fax = contact.fax;
            }
            else {
                this.model.name = value;
            }
        },
    },
}
</script>

<style>

</style>


